/**
 * Created by H
 * User: huangcan
 * Date: 2019-07-26
 * Time: 14:24
 * tips: 表格resize
 */

export default {
  inject: {
    resize: {
      from: 'isResizeCharts',
      default: null
    }
  },
  watch: {
    ['resize.globalBol']() {
      // 触发所有绑定在window上所有的图表resize事件
      window.dispatchEvent(new Event('resize'))
    }
  }
}
